/* eslint no-shadow: ["error", { "allow": ["state"] }] */
// import _ from 'lodash';
import { loadChannels } from '@/api/TimeMachine';

const state = {
  channels: null,
  loadingState: {
    isLoading: false,
  },
};

const getters = {
  channels: state => state.channels,
};

const mutations = {
  setChannels(state, channels) {
    state.channels = channels;
  },
  setLoadingState(state, isLoading) {
    state.loadingState.isLoading = isLoading;
  },
};

const actions = {
  async loadChannels({ commit }) {
    commit('setLoadingState', true);
    const response = await loadChannels();
    commit('setChannels', response.data.data);
    commit('setLoadingState', false);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
